// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.negativeMargin_n1oi2hog{margin-top:-16px;margin-left:2px;}
.standardLabelWrapper_s42w3eu{max-width:80ch;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-standards/dist/es/standard-suggest/StandardSuggest.css"],"names":[],"mappings":"AAAA,yBAAyB,gBAAgB,CAAC,eAAe,CAAC;AAC1D,8BAA8B,cAAc,CAAC","sourcesContent":[".negativeMargin_n1oi2hog{margin-top:-16px;margin-left:2px;}\n.standardLabelWrapper_s42w3eu{max-width:80ch;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
